import { render, staticRenderFns } from "./QuestWrapperComponent.vue?vue&type=template&id=0f4c060a&"
import script from "./QuestWrapperComponent.vue?vue&type=script&lang=ts&"
export * from "./QuestWrapperComponent.vue?vue&type=script&lang=ts&"
import style0 from "./QuestWrapperComponent.vue?vue&type=style&index=0&id=0f4c060a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports